import React from "react";
import { useApiProps } from "../context/apiConfigContext";
import {
  ApiConfig,
  R2DOrdersProps,
  DispatchDashboardProps,
} from "@svan-garaaz/lmd";

export interface ApiConfigProps
  extends ApiConfig, R2DOrdersProps, DispatchDashboardProps {}

export function withApiConfig<P extends object>(
  Component: React.ComponentType<P & ApiConfigProps>,
  additionalProps?: Partial<ApiConfigProps>
) {
  const WrappedComponent = (props: Omit<P, keyof ApiConfigProps>) => {
    const apiProps = useApiProps();
    if (apiProps === null) {
      return <div>Loading...</div>;
    }

    const mergedProps = {
      ...apiProps,
      ...additionalProps,
      ...props,
    } as unknown as P & ApiConfigProps;

    return <Component {...mergedProps} />;
  };

  WrappedComponent.displayName = `withApiConfig(${
    Component.displayName || Component.name
  })`;

  return WrappedComponent;
}
